var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInterpolationDisabled = function SvgInterpolationDisabled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 7C18.4477 7 18 7.44772 18 8V10.9998H7C6.44772 10.9998 6 11.4475 6 11.9998C6 12.552 6.44772 12.9998 7 12.9998H18V16C18 16.5523 18.4477 17 19 17C19.5523 17 20 16.5523 20 16V12.9998H23C23.5523 12.9998 24 12.552 24 11.9998C24 11.4475 23.5523 10.9998 23 10.9998H20V8C20 7.44772 19.5523 7 19 7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82843 14.8284C1.49509 13.4951 0.828427 12.8284 0.828427 12C0.828427 11.1716 1.49509 10.5049 2.82843 9.17157L3.17157 8.82843C4.50491 7.49509 5.17157 6.82843 6 6.82843C6.82843 6.82843 7.49509 7.49509 8.82843 8.82843L9.17157 9.17157C10.5049 10.5049 11.1716 11.1716 11.1716 12C11.1716 12.8284 10.5049 13.4951 9.17157 14.8284L8.82843 15.1716C7.49509 16.5049 6.82843 17.1716 6 17.1716C5.17157 17.1716 4.50491 16.5049 3.17157 15.1716L2.82843 14.8284Z",
    fill: "currentColor"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInterpolationDisabled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "interpolation-disabled.03172822e34623360ac161727c0ab5f2.svg";